////import _ from 'lodash';
import lo_isEqualWith from 'lodash/isEqualWith';
import lo_cloneDeep from 'lodash/cloneDeep';

ko.extenders.trackChange = function (target, options) {
    const opts = options || {};

    const enabler = options.enabler || true;

    const flagObservable = opts.flag;

    function setFlag(val) {
        if (ko.isObservable(flagObservable)) {
            flagObservable(val);
        } else {
            // maybe fill isDirty on itself?
            //target.isDirty(val);
        }

        if (val) {
            window.dispatchEvent(new CustomEvent('change-tracker', {
                detail: {
                    fieldName: options.name
                }
            }));
        }
    }

    target.isDirty = ko.observable(false);
    target._originalValue = serializeTarget();

    target.subscribe(function (newValue) {
        if (!ko.unwrap(enabler) || target.noTracking === true) {
            target._originalValue = serializeTarget();
            return;
        }

        const stdNewValue =
            typeof newValue == 'undefined' ||
                newValue == null ||
                (newValue && Object.keys(newValue).length === 0 && newValue.constructor === Object) ? null : newValue;
        const stdOrigValue =
            typeof target._originalValue == 'undefined' ||
                target._originalValue == null ||
                (target._originalValue && Object.keys(target._originalValue).length === 0 && target._originalValue.constructor === Object) ? null : target._originalValue;

        function comparer(a, b) {
            if ((typeof a === 'number' && typeof b === 'string') || typeof b === 'number' && typeof a === 'string') {
                return a.toString() == b.toString();
            }
        }

        //console.trace();
        //console.log('IS EQ', options.name, _.isEqualWith(stdOrigValue, stdNewValue, comparer), stdOrigValue, stdNewValue, typeof stdOrigValue, typeof stdNewValue);

        /*setFlag(!_.isEqualWith(stdOrigValue, stdNewValue, comparer));*/
        setFlag(!lo_isEqualWith(stdOrigValue, stdNewValue, comparer));
    });

    window.addEventListener('dirty-reset', () => {
        //console.log('reseting', target());
        target._originalValue = serializeTarget();
    })

    return target;

    function serializeTarget() {
        const cleanTarget = target() && target().toJS ? target().toJS() : target();
        /*return _.cloneDeep(cleanTarget);*/
        return lo_cloneDeep(cleanTarget);
    }
};

